/* SP Nachbestellen – Kundenkonto-Service (sections/sp-nachbestellen.liquid). Stand 10.10.2026
   Liste der Bestellungen oder (?bestellung=1151) eine Bestellung mit ihren Artikeln.
   „Übernehmen“ legt die Angaben in sessionStorage (spNbPrefill) und öffnet die Produktseite;
   assets/sp-pdp-neu.js füllt damit Farben, Mengen und Logos vor und meldet erledigte Artikel in spNbDone. */
(function () {
  'use strict';

  function json(root, sel, fb) {
    var n = root.querySelector(sel);
    if (!n) return fb;
    try { return JSON.parse(n.textContent); } catch (e) { console.error('[spk]', sel, e); return fb; }
  }
  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  function store(k, v) { try { if (v === undefined) return JSON.parse(sessionStorage.getItem(k) || 'null'); sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }

  var T = {
    de: {
      pick: 'Wähl eine Bestellung. Farben, Größen und Logos übernehmen wir – du passt nur die Mengen an.',
      none: 'Hier erscheinen deine Bestellungen, sobald du bei uns bestellt hast.',
      toShop: 'Zum Shop',
      order: 'Bestellung', of: 'vom', pcs: 'Stk.', items: 'Artikel',
      reorder: 'Nachbestellen', back: 'Alle Bestellungen',
      notFound: 'Diese Bestellung finden wir in deinem Konto nicht.',
      subOrder: function (o, n) { return 'Bestellung ' + o.name + ' vom ' + o.date + ' · ' + n + ' Stk.'; },
      open: 'Übernehmen und anpassen',
      openHint: 'Öffnet den Artikel mit Farben, Mengen und Logos. Preise und Aufpreise siehst du dort – es gelten die heutigen.',
      partner: 'Dein Artikel zum Festpreis',
      partnerBtn: 'Zur Nachbestellseite',
      gone: 'Diesen Artikel gibt es nicht mehr. Nimm einen ähnlichen – deine Logos nehmen wir mit.',
      goneNoAlt: 'Diesen Artikel gibt es nicht mehr. Such dir einen ähnlichen aus – deine Logo-Angaben stehen oben.',
      pickAlt: 'Wählen',
      done: 'Im Warenkorb',
      logo: 'Logo', file: 'Datei', noFile: 'keine Datei hinterlegt',
      cart: 'Zum Warenkorb',
      how: 'So geht’s',
      steps: [['Übernehmen', 'Der Artikel öffnet sich mit Farben, Mengen und Logos aus deiner Bestellung.'],
               ['Prüfen', 'Mengen anpassen, bei Bedarf Logo oder Position ändern, dann in den Warenkorb.'],
               ['Nächster Artikel', 'Danach kommst du hierher zurück. Erledigte Artikel sind markiert.']],
      note: 'Vor der Produktion bekommst du wie immer eine Druckfreigabe.'
    },
    en: {
      pick: 'Pick an order. Colours, sizes and logos are carried over – you only adjust the quantities.',
      none: 'Your orders will appear here once you have ordered from us.',
      toShop: 'Go to shop',
      order: 'Order', of: 'from', pcs: 'pcs', items: 'items',
      reorder: 'Reorder', back: 'All orders',
      notFound: 'We can’t find this order in your account.',
      subOrder: function (o, n) { return 'Order ' + o.name + ' from ' + o.date + ' · ' + n + ' pcs'; },
      open: 'Use and adjust',
      openHint: 'Opens the item with colours, quantities and logos. You’ll see prices and surcharges there – today’s prices apply.',
      partner: 'Your item at a fixed price',
      partnerBtn: 'Go to reorder page',
      gone: 'This item is no longer available. Pick a similar one – we’ll carry over your logos.',
      goneNoAlt: 'This item is no longer available. Choose a similar one – your logo details are listed above.',
      pickAlt: 'Choose',
      done: 'In cart',
      logo: 'Logo', file: 'File', noFile: 'no file on record',
      cart: 'Go to cart',
      how: 'How it works',
      steps: [['Use', 'The item opens with colours, quantities and logos from your order.'],
               ['Check', 'Adjust quantities, change logo or position if needed, then add to cart.'],
               ['Next item', 'You’ll come back here afterwards. Finished items are marked.']],
      note: 'As always, you’ll get a print proof to approve before production.'
    }
  };

  /* ---------- Logo-Angaben aus allen bisherigen Feld-Formen lesen ---------- */
  // 1. Logo Veredelung / 1. Logo T-Shirts hinzufügen / 1. Logo auf Latzschürzen / 1. Logo hinzufügen
  // 1. Logo Position (Stick|Digitaldruck) / Copy of 1. Logo Position (Stick) / 1. Logo Position
  // 1. Logo Breite / Logo-Größe (in cm)-1 / Logo-Größe (in cm) / Deine Bemerkung-1
  // 1. Logo Datei / Datei hochalden-1-1 / Datei hochladen-1 / Datei hochalden 2-1-1
  function logoNo(key) {
    // alte App: „Deine Bemerkung-1“ = Logo 1, „Deine Bemerkung 1“ (mit Leerzeichen) = Logo 2
    if (/^Deine Bemerkung 1\s*$/i.test(key)) return 2;
    var m = /(^|\s)(\d)\.\s*Logo/i.exec(key);
    if (m) return +m[2];
    m = /[\s-](\d)(-\d)*\s*$/.exec(key);
    if (m) return +m[1];
    return 1;
  }
  function parseLogos(props) {
    var L = {};
    function lg(n) { return (L[n] = L[n] || { n: n, fin: '', posS: '', posD: '', pos: '', width: '', widthRaw: '', fileUrl: '', fileName: '', notes: [] }); }
    props.forEach(function (kv) {
      var k = kv[0], v = String(kv[1] || '').trim(), n = logoNo(k), x;
      if (!v) return;
      if (/Vorschau/i.test(k)) return;
      if (/hinzuf(ü|ue)gen|Veredelung|Logo auf /i.test(k)) {
        x = lg(n); x.fin = /stick/i.test(v) ? 'stick' : (/druck/i.test(v) ? 'druck' : x.fin);
      } else if (/Position/i.test(k)) {
        x = lg(n);
        if (/\(\s*Stick/i.test(k)) x.posS = v; else if (/\(\s*(Digital)?druck/i.test(k)) x.posD = v; else x.pos = v;
      } else if (/Datei|hochladen|hochalden/i.test(k)) {
        x = lg(n);
        if (/^https?:\/\//i.test(v)) { x.fileUrl = v; x.fileName = fileName(v); }
        else if (!x.fileName) x.fileName = v;
      } else if (/Gr(ö|oe)(ß|ss)e|Breite|Bemerkung/i.test(k)) {
        x = lg(n); x.widthRaw = v;
        var clean = /^\s*(\d+(?:[.,]\d+)?)\s*(cm)?\s*(breit)?\s*(\([^)]*\))?\s*$/i.exec(v);
        var nums = v.match(/\d+(?:[.,]\d+)?/g) || [];
        var one = nums.length === 1 && /\d\s*cm/i.test(v) ? nums[0] : '';
        if (!x.width) x.width = (clean ? clean[1] : one).replace('.', ',');
      } else if (/Verschiebung/i.test(k)) {
        lg(n).notes.push(v);
      }
    });
    return Object.keys(L).sort().map(function (n) {
      var x = L[n];
      if (!x.pos) x.pos = x.fin === 'stick' ? (x.posS || x.posD) : (x.posD || x.posS);
      x.pos = cleanPos(x.pos);
      // Freitext bei der Größe („Siehe XS“, „max 30x15“) als Hinweis behalten
      if (x.widthRaw && !/^\s*\d+(?:[.,]\d+)?\s*(cm)?\s*(breit)?\s*(\([^)]*\))?\s*$/i.test(x.widthRaw)) x.notes.push(x.widthRaw);
      return x;
    }).filter(function (x) { return x.fin || x.pos || x.fileUrl; });
  }
  function cleanPos(p) { return String(p || '').replace(/\s*Aufpreis\s*$/i, '').replace(/\s*\(\s*max\.?[^)]*\)\s*/i, ' ').trim(); }
  function fileName(u) {
    var f = decodeURIComponent(String(u).split('?')[0].split('/').pop() || '');
    return f.replace(/_\d{12,}(\.[a-z0-9]+)$/i, '$1');
  }
  function finLabel(f, en) { return f === 'stick' ? (en ? 'Embroidery' : 'Stick') : (f === 'druck' ? (en ? 'Digital print' : 'Digitaldruck') : ''); }

  /* ---------- Bestellung → Artikel-Gruppen ---------- */
  function groups(order) {
    var G = [], idx = {};
    order.items.forEach(function (it) {
      // gleiche Logos = gleiche Gruppe, auch wenn die Datei je Größe einzeln hochgeladen wurde (Zeitstempel im Namen)
      var sig = parseLogos(it.p).map(function (x) { return [x.fin, x.pos, x.width, x.fileName].join('~'); }).join('|');
      var key = (it.h || it.t) + '|' + sig;
      var g = idx[key];
      if (!g) {
        g = idx[key] = { key: key, t: it.t, h: it.h, url: it.url, img: it.img, av: it.av, pa: it.pa, cat: it.cat, p: it.p, qty: {}, colors: [], sizes: [], total: 0 };
        G.push(g);
      }
      var parts = String(it.v || '').split(' / ');
      var color = parts.length > 1 ? parts[0] : (parts[0] || '');
      var size = parts.length > 1 ? parts.slice(1).join(' / ') : '';
      g.qty[color] = g.qty[color] || {};
      g.qty[color][size] = (g.qty[color][size] || 0) + it.q;
      if (g.colors.indexOf(color) < 0) g.colors.push(color);
      if (g.sizes.indexOf(size) < 0) g.sizes.push(size);
      g.total += it.q;
      if (!g.img && it.img) g.img = it.img;
    });
    G.forEach(function (g, i) { g.i = i; g.logos = parseLogos(g.p); });
    return G;
  }
  function qtyText(g, t) {
    return g.colors.map(function (c) {
      var keys = Object.keys(g.qty[c]);
      if (keys.length === 1 && !keys[0]) return c;
      var s = keys.map(function (sz) { return sz ? sz + ' ' + g.qty[c][sz] : String(g.qty[c][sz]); }).join(' · ');
      return (c ? c + ': ' : '') + s;
    }).filter(Boolean).concat([g.total + ' ' + t.pcs]).join(' · ');
  }

  function init(root) {
    var app = root.querySelector('[data-spk-app]');
    var cfg = json(root, '[data-spk-cfg]', {});
    var t = cfg.en ? T.en : T.de;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || cfg.root || '/';

    var login = root.querySelector('[data-spk-login]');
    if (login) login.href = '/customer_authentication/login?return_to=' + encodeURIComponent(location.pathname + location.search);
    if (!app) return;

    var orders = json(root, '[data-spk-orders]', []).filter(function (o) { return o.items && o.items.length; });
    var alts = json(root, '[data-spk-alts]', {});
    var want = (new URLSearchParams(location.search).get('bestellung') || new URLSearchParams(location.search).get('order') || '').replace(/^#/, '').trim();
    var titleEl = root.querySelector('[data-spk-title]'), subEl = root.querySelector('[data-spk-sub]');
    var done = store('spNbDone') || {};

    function pageUrl(o) { return location.pathname + '?bestellung=' + encodeURIComponent(String(o.nr)); }

    function listView() {
      if (subEl) subEl.textContent = orders.length ? t.pick : t.none;
      if (!orders.length) {
        app.innerHTML = '<a class="spk-btn" href="' + esc(cfg.shop || base) + '">' + esc(t.toShop) + '</a>';
        return;
      }
      var h = '<div class="spk-orders">';
      orders.forEach(function (o) {
        var n = 0, thumbs = [];
        groups(o).forEach(function (g) { n += g.total; if (g.img && thumbs.length < 3) thumbs.push(g.img); });
        h += '<a class="spk-card spk-order" href="' + esc(pageUrl(o)) + '">' +
          '<div class="spk-thumbs">' + thumbs.map(function (s) { return '<span class="spk-th"><img src="' + esc(s) + '" alt="" loading="lazy"></span>'; }).join('') + '</div>' +
          '<div class="spk-stack4"><span class="spk-subhead">' + esc(t.order) + ' ' + esc(o.name) + '</span>' +
          '<span class="spk-body spk-muted">' + esc(o.date) + ' · ' + n + ' ' + esc(t.pcs) + '</span></div>' +
          '<span class="spk-link spk-subhead">' + esc(t.reorder) + ' →</span></a>';
      });
      app.innerHTML = h + '</div>';
    }

    function logoHtml(g) {
      if (!g.logos.length) return '';
      return '<div class="spk-logos">' + g.logos.map(function (x) {
        var line = [finLabel(x.fin, cfg.en), x.pos, x.width ? x.width + ' cm' : ''].filter(Boolean).join(' · ');
        var file = x.fileUrl
          ? '<a class="spk-link" href="' + esc(x.fileUrl) + '" target="_blank" rel="noopener">' + esc(x.fileName || t.file) + '</a>'
          : '<span class="spk-muted">' + esc(x.fileName || t.noFile) + '</span>';
        var notes = x.notes.length ? '<span class="spk-muted">' + esc(x.notes.join(' · ')) + '</span>' : '';
        return '<div class="spk-logo"><span class="spk-no">' + x.n + '</span><div class="spk-stack4"><span class="spk-body">' + esc(line || (t.logo + ' ' + x.n)) + '</span>' +
          '<span class="spk-body">' + esc(t.file) + ': ' + file + '</span>' + notes + '</div></div>';
      }).join('') + '</div>';
    }

    function prefill(o, g, handle) {
      var same = handle === g.h;
      store('spNbPrefill', {
        v: 1, ts: Date.now(), handle: handle, order: o.name, key: o.name + '#' + g.i,
        back: pageUrl(o),
        qty: same ? g.qty : null,
        prev: qtyText(g, t),
        logos: g.logos.map(function (x) { return { fin: x.fin, pos: x.pos, width: x.width, fileUrl: x.fileUrl, fileName: x.fileName, notes: x.notes }; })
      });
    }

    function orderView(o) {
      var G = groups(o), n = 0;
      G.forEach(function (g) { n += g.total; });
      if (titleEl) titleEl.textContent = t.reorder;
      if (subEl) subEl.textContent = t.subOrder(o, n);
      var dn = done[o.name] || [];
      var h = '<a class="spk-link spk-label spk-backlink" href="' + esc(location.pathname) + '">← ' + esc(t.back) + '</a><div class="spk-items">';
      G.forEach(function (g) {
        var isDone = dn.indexOf(g.i) >= 0;
        var act = '';
        if (g.av && g.pa) {
          act = '<div class="spk-note is-ok"><span class="spk-body">' + esc(t.partner) + '</span></div>' +
            '<a class="spk-btn" href="' + esc(g.url) + '">' + esc(t.partnerBtn) + '</a>';
        } else if (g.av) {
          act = '<a class="spk-btn" data-spk-open="' + g.i + '" href="' + esc(base + 'products/' + g.h) + '">' + esc(t.open) + '</a>' +
            '<p class="spk-body spk-muted">' + esc(t.openHint) + '</p>';
        } else {
          var A = (alts[g.cat] || []);
          act = '<div class="spk-note is-warn"><span class="spk-body">' + esc(A.length ? t.gone : t.goneNoAlt) + '</span></div>';
          if (A.length) act += '<div class="spk-alts">' + A.map(function (a) {
            return '<a class="spk-alt" data-spk-alt="' + g.i + '" data-h="' + esc(a.h) + '" href="' + esc(base + 'products/' + a.h) + '">' +
              '<span class="spk-alt__img">' + (a.img ? '<img src="' + esc(a.img) + '" alt="" loading="lazy">' : '') + '</span>' +
              (a.v ? '<span class="spk-label spk-muted">' + esc(a.v) + '</span>' : '') +
              '<span class="spk-body">' + esc(a.t) + '</span><span class="spk-link spk-subhead">' + esc(t.pickAlt) + ' →</span></a>';
          }).join('') + '</div>';
        }
        h += '<article class="spk-card spk-item' + (isDone ? ' is-done' : '') + '">' +
          '<div class="spk-item__main">' +
            '<span class="spk-th spk-th--l">' + (g.img ? '<img src="' + esc(g.img) + '" alt="" loading="lazy">' : '') + '</span>' +
            '<div class="spk-stack8">' +
              (isDone ? '<span class="spk-chip">' + esc(t.done) + ' ✓</span>' : '') +
              '<h2 class="spk-heading">' + esc(g.t) + '</h2>' +
              '<p class="spk-body spk-muted">' + esc(qtyText(g, t)) + '</p>' +
              logoHtml(g) +
            '</div>' +
          '</div>' +
          '<div class="spk-item__act">' + act + '</div>' +
        '</article>';
      });
      h += '</div>';
      if (dn.length) h += '<a class="spk-link spk-subhead" href="' + esc(base + 'cart') + '">' + esc(t.cart) + ' →</a>';
      h += '<div class="spk-card spk-how"><h2 class="spk-heading">' + esc(t.how) + '</h2><ol class="spk-steps">' +
        t.steps.map(function (s, i) { return '<li><span class="spk-no">' + (i + 1) + '</span><div class="spk-stack4"><span class="spk-subhead">' + esc(s[0]) + '</span><span class="spk-body spk-muted">' + esc(s[1]) + '</span></div></li>'; }).join('') +
        '</ol><p class="spk-body spk-muted">' + esc(t.note) + '</p></div>';
      app.innerHTML = h;

      app.querySelectorAll('[data-spk-open]').forEach(function (a) {
        a.addEventListener('click', function () { var g = G[+a.getAttribute('data-spk-open')]; prefill(o, g, g.h); });
      });
      app.querySelectorAll('[data-spk-alt]').forEach(function (a) {
        a.addEventListener('click', function () { var g = G[+a.getAttribute('data-spk-alt')]; prefill(o, g, a.getAttribute('data-h')); });
      });
    }

    if (want) {
      var o = null;
      orders.forEach(function (x) { if (String(x.nr) === want || String(x.name).replace(/^#/, '') === want) o = x; });
      if (o) return orderView(o);
      app.innerHTML = '<div class="spk-note is-warn"><span class="spk-body">' + esc(t.notFound) + '</span></div>';
      var keep = app.innerHTML;
      listView();
      app.innerHTML = keep + app.innerHTML;
      return;
    }
    listView();
  }

  function start() { document.querySelectorAll('[data-spk]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
